import React from 'react';
import { Field } from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

const HiddenReferencesField = ( references ) => (
    <Field
        name='output_client_references'
        className='output_client_references'
        component={Form.SemanticInput}
        type='hidden'
        value={JSON.stringify(references)}
        defaultValue={JSON.stringify(references)}
    />
);

export default HiddenReferencesField;
